import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
    import CustomerSurveyQuestion from './CustomerSurveyQuestion.vue';
    import { useGlobalStore } from '@/store/global';
    import { ISurveyEntry } from '@/interfaces/ISurveyEntry';
    import { ISurveyEntryQuestionAnswer } from '@/interfaces/ISurveyEntryQuestionAnswer';
    import Vue from 'vue';
    import { ISurveyEntryQuestion } from '@/interfaces/ISurveyEntryQuestion';
    import { useCustomerStore } from '@/store/customer';
    import { ISurveyAnswer } from '@/interfaces/ISurveyAnswer';
    import { Country } from '@/enums/Country';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerSurveyFull',
  setup(__props) {

    const globalStore = useGlobalStore();
    const customerStore = useCustomerStore();

    const openCalendlyModal = ref(false);

    /** Logic for when to show survey */
    const surveyDisplayed = ref(false);

    async function checkIfSurveyShouldBeShown() {
        if (
            globalStore.survey &&
            globalStore.survey.id &&
            customerStore.customer.mail_address !== ''
        ) {
            const response = await globalStore.checkIfSurveyShouldBeShown(
                customerStore.customer.mail_address,
                globalStore.survey.id,
            );
            if (
                response.show_survey &&
                !globalStore.surveysDismissed.includes(globalStore.survey.id)
            )
                setTimeout(() => {
                    surveyDisplayed.value = true;
                    Vue.prototype.$posthog.capture('Custom Survey: Shown', {
                        country: globalStore.country,
                        survey_id: globalStore.survey ? globalStore.survey.id : undefined,
                    });
                }, 5000);
            else surveyDisplayed.value = false;
        }
    }

    if (globalStore.survey) checkIfSurveyShouldBeShown();
    watch(
        () => globalStore.survey,
        (_val) => {
            if (_val !== undefined) checkIfSurveyShouldBeShown();
        },
    );

    /** Logic for answering */
    const page = ref(1);
    const chosenEntry = ref<ISurveyEntry>();
    const chosenAnswers = ref<ISurveyEntryQuestion[]>([]);

    function setAnswer(question: ISurveyEntryQuestion, answer: ISurveyEntryQuestionAnswer) {
        // Check if question is already answered
        const currentQuestionIndex = chosenAnswers.value.findIndex((val) => val.id === question.id);
        if (currentQuestionIndex > -1) {
            // If multiple answers are not allowed just overwrite answer
            if (!question.multiple_answers) {
                chosenAnswers.value[currentQuestionIndex].answers = [answer];
            } else {
                // Else check if answer is already given, if yes then remove if not add
                const currentAnswerIndex =
                    chosenAnswers.value[currentQuestionIndex].answers.indexOf(answer);

                if (currentAnswerIndex > -1) {
                    chosenAnswers.value[currentQuestionIndex].answers.splice(currentAnswerIndex, 1);
                } else {
                    chosenAnswers.value[currentQuestionIndex].answers.push(answer);
                }
            }
        } else {
            const questionWithNewAnswer = { ...question };
            questionWithNewAnswer.answers = [answer];
            chosenAnswers.value.push(questionWithNewAnswer);
        }
    }

    function gotAnswer(question: ISurveyEntryQuestion, answer: ISurveyEntryQuestionAnswer) {
        const currentQuestion = chosenAnswers.value.find((val) => val.id === question.id);
        if (currentQuestion) return currentQuestion.answers.includes(answer);
        else return false;
    }

    function toPageTwo() {
        page.value = 2;
        Vue.prototype.$posthog.capture('Custom Survey: Answer Question 1', {
            country: globalStore.country,
            survey_id: globalStore.survey ? globalStore.survey.id : undefined,
            chosenEntry: chosenEntry.value,
        });
        if (globalStore.survey && chosenEntry.value) {
            globalStore.sendSurveyAnswer({
                survey_id: globalStore.survey.id,
                survey_entry_id: chosenEntry.value.id,
                lead_email: customerStore.customer.mail_address,
            });
        }
    }

    function surveyDismissed() {
        surveyDisplayed.value = false;
        if (globalStore.survey) {
            globalStore.surveysDismissed.push(globalStore.survey.id);
        }
        Vue.prototype.$posthog.capture('Custom Survey: Dismissed', {
            country: globalStore.country,
            survey_id: globalStore.survey ? globalStore.survey.id : undefined,
        });
    }

    function surveyFinished() {
        surveyDisplayed.value = false;
        // Add to dismissed so it doesn't show when changing mail address
        if (globalStore.survey) {
            globalStore.surveysDismissed.push(globalStore.survey.id);
        }

        Vue.prototype.$posthog.capture('Custom Survey: Answer Question 2', {
            country: globalStore.country,
            survey_id: globalStore.survey ? globalStore.survey.id : undefined,
            chosenAnswers: chosenAnswers.value,
        });

        // Convert answers to correct structure to send
        const convertedAnswers = chosenAnswers.value.map((val): ISurveyAnswer | undefined => {
            if (globalStore.survey && chosenEntry.value)
                return {
                    survey_id: globalStore.survey.id,
                    survey_entry_id: chosenEntry.value.id,
                    question_id: val.id,
                    answers: val.answers.map((val) => val.id),
                    lead_email: customerStore.customer.mail_address,
                };
        });
        convertedAnswers.forEach((val) => {
            if (val && val.answers && val.answers.length > 0) globalStore.sendSurveyAnswer(val);
        });

        // Open calendly modal if consultation is selected
        if (
            chosenAnswers.value.findIndex((val) =>
                val.answers.findIndex((val) => val.tags.includes('Consultation_Requested')),
            )
        ) {
            openCalendlyModal.value = true;
            Vue.prototype.$posthog.capture('Custom Survey: Open Calendly Modal');
        } else openCalendlyModal.value = false;
    }

return { __sfc: true,globalStore, customerStore, openCalendlyModal, surveyDisplayed, checkIfSurveyShouldBeShown, page, chosenEntry, chosenAnswers, setAnswer, gotAnswer, toPageTwo, surveyDismissed, surveyFinished, CustomerSurveyQuestion, Country }
}

})